import { Injectable } from '@angular/core';
import Quill from 'quill';
import { ClubPublicationService } from '../services/publication.service';

@Injectable({
    providedIn: 'root',
})
export class CommentQuillEditorHelper {
    constructor(private readonly publicationService: ClubPublicationService) {}

    public readonly modulesForCommentsPosts = {
        toolbar: [
            ['bold', 'italic', 'underline', 'link'],
            [{ list: 'ordered' }, { list: 'bullet' }],
        ],
        clipboard: {
            matchers: [
                [
                    'img',
                    (node: any) => {
                        const Delta = Quill.import('delta');
                        return new Delta().insert('');
                    },
                ],
                [
                    'p',
                    (node: any) => {
                        const Delta = Quill.import('delta');
                        return new Delta().insert(node.textContent + '\n');
                    },
                ],
                [
                    'br',
                    () => {
                        const Delta = Quill.import('delta');
                        return new Delta().insert('\n');
                    },
                ],
            ],
            matchVisual: false,
        },
        keyboard: {
            bindings: [
                {
                    key: 13,
                    handler: () => {
                        return !this.publicationService.isMentionOpened;
                    },
                },
            ],
        },
    };

    public readonly noToolbar = { toolbar: false };
}
